import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../service/api.service';

@Component({
  selector: 'app-allergens-footer',
  templateUrl: './allergens-footer.component.html',
  styleUrls: ['./allergens-footer.component.scss'],
})
export class AllergensFooterComponent implements OnInit, OnDestroy {
  allergens = [];
  AllergensBottomText: string;
  DineInBottomText: string;
  showDineInBottomText: boolean;
  webCusSub: Subscription;

  constructor(private apiService: ApiService) {}

  /** The dine-in wording when this is a dine-in page, the standard one otherwise. */
  get noteText(): string {
    return this.showDineInBottomText
      ? this.DineInBottomText
      : this.AllergensBottomText;
  }

  ngOnInit(): void {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.DineInBottomText = res.TemplateData?.DineInBottomText;
      this.allergens = res.Allergens;
      this.AllergensBottomText = res.TemplateData.AllergensBottomText;
    });
  }
  ngOnDestroy(): void {
    this.webCusSub?.unsubscribe();
  }
}
